import { RequestParams, ResponseCatalog } from 'Models'
import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { City } from 'Pages/orders_design'

async function getItems(requestParams: RequestParams) {
	const res = await axiosDS().get<ResponseCatalog<City>>(urls.common.catalogs.mq_city, {
		params: requestParams,
	})
	return res.data
}

async function getMissing(id: number) {
	const res = await axiosDS().get<City>(`${urls.common.catalogs.mq_city}/${id}`)
	return res.data
}

export const cityMqApi = {
	getItems,
	getMissing,
}
